import { MessageService } from "./../services/message.service";
import { Message } from "./../common/message";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material";
import { ConfirmDeleteDialogComponent } from "../dialog/confirm-delete-dialog/confirm-delete-dialog.component";
import { TroubleshootingqaboxService } from "../services/troubleshootingqabox.service";
import { Troubleshootingqabox } from "../models/troubleshootingqabox";

let ELEMENT_DATA = [];
@Component({
  selector: "app-troubleshootingqabox",
  templateUrl: "./troubleshootingqabox.component.html",
  styleUrls: ["./troubleshootingqabox.component.scss"],
})
export class TroubleshootingqaboxComponent implements OnInit {
  form: FormGroup;
  submitted = false;
  success = false;
  ELEMENT_DATA: any[];
  displayedColumns: string[] = ["sn", "name", "desc", "actions"];
  dataSource = new MatTableDataSource();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  isFormDisplay: boolean = false;
  isAddNew: boolean = true;
  resource: Troubleshootingqabox = new Troubleshootingqabox();

  constructor(
    private dialog: MatDialog,
    private service: TroubleshootingqaboxService,
    private formBuilder: FormBuilder,
    private msg: MessageService
  ) {}

  ngOnInit() {
    this.resource = new Troubleshootingqabox();
    this.setMessageForm();
    this.getResources();
  }

  setMessageForm() {
    this.form = this.formBuilder.group({
      sn: ["", Validators.required],
      name: ["", Validators.required],
      desc: [null, Validators.required],
    });
  }

  getResources() {
    ELEMENT_DATA = [];
    this.service.getAll().subscribe((result) => {
      ELEMENT_DATA = ELEMENT_DATA.concat(result);
      this.updateDataSource();
    });
  }

  updateDataSource() {
    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
    this.dataSource.paginator = this.paginator;
  }

  displayForm() {
    this.resource = new Troubleshootingqabox();
    this.isFormDisplay = true;
  }

  displayTable() {
    this.isFormDisplay = false;
    this.resetForm();
  }

  onSave(sn: HTMLDataElement, name: HTMLDataElement, desc: HTMLDataElement) {
    this.submitted = true;

    if (this.form.controls.sn.errors) {
      return;
    }

    if (this.form.controls.name.errors) {
      return;
    }

    if (this.form.controls.desc.errors) {
      return;
    }

    if (this.resource.id) {
      this.updateElement(sn, name, desc);
    } else {
      this.addElement(sn, name, desc);
    }
  }

  resetForm(ret?: boolean) {
    this.form.reset();
    this.submitted = false;
    if (ret) this.isFormDisplay = false;
  }

  addElement(sn, name, desc) {
    this.resource.setName(name.value);
    this.resource.setDesc(desc.value);
    this.resource.setSn(sn.value);

    this.service.create(this.resource).subscribe((result) => {
      this.msg.alert(Message.SAVE);
      ELEMENT_DATA.push(result);
      this.updateDataSource();
      this.resource = new Troubleshootingqabox();
      this.resetForm();
    });
  }

  updateElement(sn, name, desc) {
    this.resource.setName(name.value);
    this.resource.setDesc(desc.value);
    this.resource.setSn(sn.value);

    this.service.update(this.resource).subscribe((result) => {
      this.msg.alert(Message.UPDATE);
      ELEMENT_DATA.forEach((elem, index) => {
        if (elem.id === this.resource.id) {
          ELEMENT_DATA.splice(index, 1, result);
          return;
        }
      });

      this.updateDataSource();
      this.resource = new Troubleshootingqabox();
      this.resetForm(true);
    });
  }

  editElement(ele) {
    this.isFormDisplay = true;
    this.isAddNew = false;
    this.resource = ele;
    this.resource = new Troubleshootingqabox();

    this.resource.setId(ele.id);
    this.resource.setName(ele.name);
    this.resource.setDesc(ele.desc);
    this.resource.setSn(ele.sn);

    this.form.controls.name.setValue(ele.name);
    this.form.controls.desc.setValue(ele.desc);
    this.form.controls.sn.setValue(ele.sn);
  }

  deleteElement(ele) {
    this.dialog
      .open(ConfirmDeleteDialogComponent)
      .afterClosed()
      .subscribe((result) => {
        if (result === "true") {
          this.service.delete(ele.id).subscribe((result) => {
            this.msg.alert(Message.DELETE);
            let index = ELEMENT_DATA.indexOf(ele);
            ELEMENT_DATA.splice(index, 1);
            this.updateDataSource();
          });
        } else {
          return;
        }
      });
  }
}
